// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { DELETE_ORGANIZATION } from "./action";

export function canDeleteOrganization(scope: Scope): boolean {
  return scope.iamActions.includes(DELETE_ORGANIZATION);
}
